import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { BookingSlot } from '../../../booking/models/booking-slot';

@Component({
  selector: 'app-time-slots-event',
  templateUrl: './time-slots-event.component.html',
  styleUrls: ['./time-slots-event.component.css']
})
export class TimeSlotsEventComponent implements OnInit {

  @Input()
  timeSlots: BookingSlot[];

  @Output()
  timeSlotSelected: EventEmitter<BookingSlot> = new EventEmitter<BookingSlot>();

  constructor(
  ) { }

  ngOnInit() {
  }

  onClickTimeSlot(timeSlot: BookingSlot) {
    this.timeSlotSelected.emit(timeSlot);
  }

  getHourString(floatTime: number): string {
    return environment.globalSettings.getHourString(floatTime);
  }

  getMinutesString(floatTime: number): string {
    return environment.globalSettings.getMinutesString(floatTime);
  }

  get groupedTimeSlots(): BookingSlot[] {
    const timeOfSlots = [];
    const groupedTimeSlots = [];

    this.timeSlots.forEach(
      timeSlot => {
        if (timeSlot.fromTime && timeSlot.toTime) {
          const currentTimeSlotStr = timeSlot.fromTime.toString() + ' ' + timeSlot.toTime.toString();
          if (timeOfSlots.indexOf(currentTimeSlotStr) === -1) {
            timeOfSlots.push(currentTimeSlotStr);
            groupedTimeSlots.push(timeSlot);
          }
        }
      }
    );
    if (groupedTimeSlots) {
      return groupedTimeSlots;
    }

    return this.timeSlots;
  }

}
